module.exports = __webpack_public_path__ + "static/img/csjsd.1a4f810.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/csjsd.jpg
// module id = nOpL
// module chunks = 21